export default __webpack_public_path__ + "static/media/belt_of_vengeful_zeal.8acdf99e.jpg";